import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { SchedulingStatusService, ISchedulingStatus } from './scheduling-status.service';

class ChartData {
  status: ISchedulingStatus;
  value: number;
}

@Component({
  selector: 'app-scheduling-status-chart',
  templateUrl: './scheduling-status-chart.component.html',
  styleUrls: ['./scheduling-status-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulingStatusChartComponent implements OnChanges {
  @Input() data: [{ status: string, value: number }];
  @Output() statusSelected = new EventEmitter<string>();

  public chartData: Array<ChartData> = [];
  public maxValue = 0;

  public selectedSchedulingStatus = '';

  constructor(private schedulingStatusService: SchedulingStatusService, private cdRef: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.data) {
      this.chartData = [];
      this.schedulingStatusService.getTaskSchedulingStatuses().forEach(status => {
        const chartItem = new ChartData();
        chartItem.status = status;
        chartItem.value = 0;

        this.chartData.push(chartItem);
      });

      this.maxValue = 0;

      this.data.forEach(item => {
        const chartItem = this.chartData.find(o => o.status.value === item.status);
        chartItem.value = item.value;

        if (item.value > this.maxValue) {
          this.maxValue = item.value;
        }
      });

      this.cdRef.detectChanges();
    }
  }

  selectSchedulingStatus(status: string) {
    if (this.selectedSchedulingStatus === status) {
      this.selectedSchedulingStatus = '';
    } else {
      this.selectedSchedulingStatus = status;
    }
    this.statusSelected.emit(this.selectedSchedulingStatus);
  }

}
